import React, { createContext, useContext, useEffect, useState } from 'react'
import config from '../../environment-config'

const DEFAULT_VALUE = true
const IS_LOCAL = config.environment === 'local'
const COBRA_URL = config.serviceURLs?.cobraURL || ''

export const PhoneAvailabilityContext = createContext(true)
export const usePhoneAvailability = () => useContext(PhoneAvailabilityContext)

/**
 * @param {string} domain - the domain of the site
 * @param {string} brand - the brand token
 */
async function getAvailability(domain, brand) {
  return fetch(`${COBRA_URL}${domain || ''}`)
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      const status = data[brand]?.status
      if (!status) {
        console.info(
          "Leshen:UI:Mapi - Cobra request returned 200, but no data found for that path. Check the `cobra.sitePath` and `brandToken` in this site's gatsby-config.js"
        )
      }
      return status !== 'Closed'
    })
    .catch((err) => {
      console.error(
        'Leshen:UI:Mapi - Cobra request unsuccessful, does this site have Cobra available?',
        err
      )
      return false
    })
}

/**
 * @param {Object} props - The properties passed to CobraProvider.
 * @param {string|null} [props.domain] - The domain of the site.
 * @param {string|null} [props.brand] - The brand token.
 * @param {React.ReactNode} [props.children] - The child components to render within the provider.
 */
export function PhoneAvailabilityProvider({ domain, brand, children }) {
  const [available, setAvailable] = useState(DEFAULT_VALUE)

  useEffect(() => {
    const isSSR = typeof window === 'undefined'
    if (!domain || !brand || isSSR || IS_LOCAL) return
    getAvailability(domain, brand).then((v) => {
      setAvailable(v)
    })
  }, [domain, brand, setAvailable])

  return (
    <PhoneAvailabilityContext.Provider value={available}>
      {children}
    </PhoneAvailabilityContext.Provider>
  )
}
